import { render } from "./SearchResult.vue?vue&type=template&id=6de54d95"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dominikheun/Coding/ktg-dealersearch-relaunch-typo3/extensions/ktg-dealersearch-extension-typo3/Resources/Private/Vue/dealersearch-list/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__